module.exports = __webpack_public_path__ + "static/media/mapa.0a3c050e.svg";